import { ShoppingBag } from "lucide-react";

export function CartEmpty() {
    return (
        <div className="h-full flex flex-col items-center justify-center text-stone-400 space-y-4">
            <ShoppingBag size={48} strokeWidth={1} />
            <p className="font-light">Your bag is currently empty.</p>
        </div>
    );
}
